export default __webpack_public_path__ + "static/media/Shadow's Gloves of Ushering Twilight.f83d0936.jpg";